import type { InsightStatus } from '../models/insight.types'
import { reportInsightStatusWriteFailure } from '../telemetry/insightStatusTelemetry'

import { ApiError } from '@/shared/http'

/** Starts the audited status write without making detail presentation wait on its outcome. */
export function runNonBlockingStatusWrite(
  write: () => Promise<void>,
  onSuccess: () => void,
  attemptedStatus: InsightStatus,
): void {
  void write()
    .then(onSuccess)
    .catch((cause: unknown) => {
      const error = ApiError.isApiError(cause) ? cause : ApiError.fromAxios(cause)
      if (error.kind === 'canceled') return
      reportInsightStatusWriteFailure({
        attemptedStatus,
        kind: error.kind,
        status: error.status,
        code: error.code,
      })
    })
}
